export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    description: '',
    qty: 1,
    unit_rate: 0,
    item_edit: 0
}

export let dataProps = {
    id: 0,
    from_store_id: null, 
    to_store_id: null,
    transfer_number: null,
    transfer_date: new Date(), 
    generated_by_staff_id: null, 
    status: 0,//draft, dispatched, accepted, canceled
    
    dispatch_date: new Date(),
    dispatch_by_staff_id: null,
    dispatch_notes: '',
    delivered_by_staff_id: null,
    
    accept_date: new Date(), 
    accept_by_staff_id: null, 
    accept_notes: '', 
    
    total_cost: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryIntraBranch/properties.js